import { render, staticRenderFns } from "./InfoP.vue?vue&type=template&id=2c855558"
import script from "./InfoP.vue?vue&type=script&lang=js"
export * from "./InfoP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports